import styled from 'styled-components'
import { Breadcrumb as AntBreadcrumb } from 'antd'
import { fontSizes } from '../../general/Typography/Text/Text'

const BreadcrumbStyled = styled(AntBreadcrumb)<{ $weight?: undefined }>`
  .ant-breadcrumb-link {
    color: ${({ theme }) => theme.color.neutral.color5};
  }
  .ant-breadcrumb-link a {
    color: ${({ theme }) => theme.color.neutral.color5};
  }
  .ant-breadcrumb-link a {
    :hover {
      color: ${({ theme }) => theme.color.neutral.color3};
    }
  }

  ${fontSizes[1]}
` as unknown as typeof AntBreadcrumb
// we don't provide weight prop here
// it is just a type safty

const Breadcrumb = BreadcrumbStyled

export default Breadcrumb
